import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { FamilyHeadProvider } from './Context/FamilyHeadContext'
import './i18n.jsx'
import './index.css'

// אתחול Google Analytics
ReactGA.initialize('G-529Y7DW80W')
ReactGA.send('pageview')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.Fragment>
    <BrowserRouter>
      <FamilyHeadProvider>
        <App />
      </FamilyHeadProvider>
    </BrowserRouter>
  </React.Fragment>,
)
